import { Checkbox } from '@components/common/Checkbox';
import { Controller, useFormContext } from 'react-hook-form';
import { ICheckboxProps } from './types';

export const FormCheckbox = (props: ICheckboxProps) => {
  const form = useFormContext();
  const { rules, name, ...checkboxProps } = props;

  return (
    <Controller
      rules={rules}
      name={name || ''}
      control={form.control}
      render={({ field: { ref, value, onChange, onBlur, name: fieldName } }) => (
        <Checkbox
          {...checkboxProps}
          name={fieldName}
          checked={Boolean(value)}
          inputRef={ref}
          onBlur={onBlur}
          onChange={(_event, checked) => onChange(checked)}
        />
      )}
    />
  );
};
